import { IStore } from 'Store/.';
import { createSelector } from 'reselect';

const getIsFetchingFaq = (state: IStore) => state.infoFaq.isFetching;
const getIsFetchFaqFailed = (state: IStore) => state.infoFaq.isFetchFailed;
const getFaqList = (state: IStore) => state.infoFaq.faqList;

export {
  getIsFetchingFaq,
  getIsFetchFaqFailed,
  getFaqList,
};


// WEBPACK FOOTER //
// ./src/components/InfoFaq/Redux/selectors.tsx